import React, {useEffect, useState} from 'react'
import {useAuth} from '../../modules/auth'
import axios from 'axios'


/*const API_URL = import.meta.env.VITE_APP_API_URL;
  const {currentUser, logout} = useAuth()

  const [FirstName, setFirstName] = useState()
  const [LastName, setLastName] = useState()
  const [Email, setEmail] = useState()
  const [EstatusPago, setEstatusPago] = useState()
  const [Rfc, setRfc] = useState()
  const [RazonSocial, setRazonSocial] = useState()
  const [DireccionFiscal, setDireccionFiscal] = useState()
  const [RegimenFiscal, setRegimenFiscal] = useState()
  const [UsoCfdi, setUsoCfdi] = useState()
  const [MetodoPago, setMetodoPago] = useState()
  const [Telefono, setTelefono] = useState()

  const myProfile = () => {
    axios
    .get(API_URL + '/miPerfil/' + currentUser.id)
    .then((response) => {
      console.log(response.data)

      var first_name = response.data[0].first_name;
      var last_name = response.data[0].last_name;
      var email =response.data[0].email;
      var estatus_pago =response.data[0].estatus_pago;
      var rfc = response.data[0].rfc;
      var razon_social = response.data[0].razon_social;
      var direccion_fiscal = response.data[0].direccion_fiscal;
      var regimen_fiscal = response.data[0].regimen_fiscal;
      var uso_cfdi = response.data[0].uso_cfdi;
      var metodo_pago = response.data[0].metodo_pago;
      var telefono = response.data[0].telefono;
     

      console.log(first_name)

      setFirstName(first_name);
      setLastName(last_name);
      setEmail(email);
      setEstatusPago(estatus_pago);
      setRfc(rfc);
      setRazonSocial(razon_social);
      setDireccionFiscal(direccion_fiscal);
      setRegimenFiscal(regimen_fiscal);
      setUsoCfdi(uso_cfdi);
      setMetodoPago(metodo_pago);
      setTelefono(telefono);
      })
      .catch((error) => console.error(error))
  }

  useEffect(() => {
    myProfile()
  }, [])*/






function ModalUsuario(props) {
  const usuario = props.usuario
  //const API_URL = process.env.REACT_APP_API_URL

  
  const displayUser = () => {
    if (usuario) {
      if (usuario.length > 0) {
        return usuario.map((usuario, index) => {
          return (
            
      
            <div className='card-body'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Nombre</label>
      
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-gray-900'>{usuario.first_name}</span>
                </div>
              </div>
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Apellidos</label>
      
                <div className='col-lg-8 fv-row'>
                  <span className='fw-bold fs-6'>{usuario.last_name}</span>
                </div>
              </div>
      
         
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Correo</label>
      
                <div className='col-lg-8'>
                  <a href='#' className='fw-bold fs-6 text-gray-900 text-hover-primary'>
                  {usuario.email}
                  </a>
                </div>
              </div>
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Telefono</label>
      
                <div className='col-lg-8'>
                  <a href='#' className='fw-bold fs-6 text-gray-900 text-hover-primary'>
                  {usuario.phone}
                  </a>
                </div>
              </div>
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Empresa</label>
      
                <div className='col-lg-8'>
                  <a href='#' className='fw-bold fs-6 text-gray-900 text-hover-primary'>
                  {usuario.company}
                  </a>
                </div>
              </div>
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Número de empleados</label>
      
                <div className='col-lg-8'>
                  <a href='#' className='fw-bold fs-6 text-gray-900 text-hover-primary'>
                  {usuario.employees}
                  </a>
                </div>
              </div>
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Estado</label>
      
                <div className='col-lg-8'>
                  <a href='#' className='fw-bold fs-6 text-gray-900 text-hover-primary'>
                  {usuario.state}
                  </a>
                </div>
              </div>
      
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Ciudad</label>
      
                <div className='col-lg-8'>
                  <a href='#' className='fw-bold fs-6 text-gray-900 text-hover-primary'>
                  {usuario.city}
                  </a>
                </div>
              </div>
            </div>
          )
        })
      }
    }
  }

  return <>{displayUser()}</>
}
  

export {ModalUsuario}



